import { useTranslation } from "react-i18next";

export const useRequiredValidation = () => {
  const { t } = useTranslation();

  return {
    required: t("notis.error.required", "Toto pole je povinné"),
  };
};
